import * as R from 'ramda';
import { Queue } from '../types/queue';

export function getQueueSelector(queueId: string | null | undefined) {
  const id = queueId ? queueId.toString() : null;
  return R.find(R.propEq(id, 'id'));
}

export function getQueueIndexSelector(queueId: string | null | undefined) {
  const id = queueId ? queueId.toString() : null;
  return R.findIndex(R.propEq(id, 'id'));
}

export function getCloudQueueByNumber(number: string | null | undefined) {
  return R.find(R.propEq(number, 'sequenceId'));
}

export function allQueuesEmpty(queues: Array<Queue>) {
  return R.all((q: Queue) => R.isEmpty(q.tickets))(queues);
}
